const InfoAdvisor = _ => import(/* webpackChunkName: "js/split/InfoAdvisor"*/'@/components/views/home/advisor/partials/InfoAdvisor');

const modelLocation = _ => {
	return {
		geo_cat_country_id: 59,
		geo_cat_state_id: null,
		geo_locality_id: null,
		neighborhood_id: null,
		postal_code_id: null,
		streetName: null,
		streetNumber: null,
		interiorStreetNumber: null,
	}
};

const modelInfoProfileAdvisor = _ => {
	return {
		id: null,
		hash_id: null,
		name: null,
		last_name: null,
		cat_advisor_type_id: null,
		company_type_id: null,

        second_last_name: null,
        employees_number: null,
        beneficiaries_number: null,
        cat_advisor_activities: [],
		geo_cat_state_id: null,
        person: {
	        name: null,
	        surName: null,
	        secondSurName: null,
			contact_home: modelLocation(),
            contact_email: {
				email: null
			},
			contact_phones: [],
	        mobile_phone: null,
	        landline_phone: null,
		},
		legal: {
			dui: null,
			name: null,
			surName: null,
			secondSurName: null,	
		}
	}

};

export const completeAdvisorProfileMix = {

	components: {
		InfoAdvisor
	},
	data(){
		return {
			infoProfileAdvisor: modelInfoProfileAdvisor(),
			onlyRead: false,
			newInbox:null
		}
	},
	created() {
		this.initServiceCompleteAdvisor();
	},
	methods:{
		initServiceCompleteAdvisor(){
			window.axios('/api/public/advisors/get-advisor-profile').then(response => {
				if (response.data.success) {
					let info = response.data.data;
					if(!info.person.contact_home) {
						info.person.contact_home = modelLocation()
					}
					this.infoProfileAdvisor = info;
					this.newInbox = response.data.newInbox;

					if(info.isCompleted && (info.isCompleted == true || info.isCompleted == 1 )){
						this.onlyRead = true;
					}
					
				}
			}).catch(error => {
			});

		}
	}
};